import isObject from './isObject.js';

/**
 * Serialize object to query string
 * @param {object} queryObject
 * @param {boolean} [encode=true]
 * @returns {string}
 */
export default (queryObject, encode = true) => {
	if (!isObject(queryObject)) {
		return '';
	}
	const serializedQueryPairs = Object.entries(queryObject).reduce((serialized, [key, queryValue]) => {
		const queryValueArray = Array.isArray(queryValue) ? queryValue : [queryValue];
		queryValueArray.forEach((value) => serialized.push(`${key}=${encode ? encodeURIComponent(value) : value}`));
		return serialized;
	}, []);
	return serializedQueryPairs.join('&');
};
